var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":function($event){return _vm.onClickHotRecommend(_vm.item.word)}}},[_c('van-icon',{attrs:{"name":"orders-o","size":"1.2em"}}),_vm._v(_vm._s(_vm.item.word))],1)}
var staticRenderFns = []

export { render, staticRenderFns }